export default (() => {

    const AlignFlex = (options) => {

        const validNames = {
            JustifyContent: 'justifycontent',
            AlignItems: 'alignitems'
        };

        const flexAlignmentValues = ['start', 'center', 'end'];
        const flexJustifyValues = ['space-between'];
        const nameValid = options.name && wealthify.type.array.includes(options.name, Object.values(validNames));


        if (!nameValid) {
            return wealthify.error.throwError('Align prop', `Name passed to Align prop is invalid. Must be one of the following - ${Object.values(validNames).join(', ')}`);
        }

        if (options.name === validNames.JustifyContent) {
            flexAlignmentValues.push(...flexJustifyValues);
        }

        return new wealthify.Prop(options.name, {
            nullable: true,
            type: wealthify.propTypes.ArrayItem(flexAlignmentValues),
            onChangeCallback: (value, component) => {
                const rootElement = component.dom.childRoot ? component.dom.childRoot : component.dom.root;

                flexAlignmentValues.forEach((option) => {
                    component.classList.remove(`u-flex__${options.name}--${option}`);
                    rootElement.classList.remove(`u-flex__${options.name}--${option}`);
                });
                if (!value) {
                    return;
                }
                component.classList.add(`u-flex__${options.name}--${value}`);
                rootElement.classList.add(`u-flex__${options.name}--${value}`);
            }
        });
    };

    const AlignText = () => {

        const validOptions = [  'left', 'center', 'right' ];

        return new wealthify.Prop('aligntext', {
            nullable: true,
            type: wealthify.propTypes.ArrayItem(validOptions),
            onChangeCallback: (value, component) => {
                let rootElements = [component.dom.root];

                if (component.dom.childRoot) {
                    rootElements.push(component.dom.childRoot);
                }

                validOptions.forEach((option) => {
                    component.classList.remove(`u-text__align--${option}`);
                    rootElements.forEach((element) => element.classList.remove(`u-text__align--${option}`));
                });
                if (!value) {
                    return;
                }
                component.classList.add(`u-text__align--${value}`);
                rootElements.forEach((element) => element.classList.add(`u-text__align--${value}`));
            }
        });
    };

    const AriaHidden = (options) => new wealthify.Prop('ariahidden', {
        ...options,
        default: false,
        type: wealthify.propTypes.Boolean(),
        onChangeCallback: (value, component) => {
            if (value) {
                component.dom.root.setAttribute('aria-hidden', true);
                component.dom.root.setAttribute('tabindex', -1);
            } else {
                component.dom.root.removeAttribute('aria-hidden');
                component.dom.root.removeAttribute('tabindex');
            }
        }
    });

    // TODO AriaDisabled implementation to eventually replace Disabled as default mechanism for disabling elements -
    // allowing users, screen readers & assistive tech to focus disabled elements. 
    const AriaDisabled = (options) => new wealthify.Prop('ariadisabled', {
        ...options,
        default: false,
        type: wealthify.propTypes.Boolean(),
        onChangeCallback: (value, component) => {
            if (value) {
                component.dom.root.classList.add(`${component.styleSelector}--aria-disabled`);
                component.dom.root.setAttribute('aria-disabled', true);
            } else {
                component.dom.root.classList.remove(`${component.styleSelector}--aria-disabled`);
                component.dom.root.removeAttribute('aria-disabled');
            }
        }
    });

    const DarkMode = (options) => new wealthify.Prop('darkmode', {
        ...options,
        default: false,
        type: wealthify.propTypes.Boolean(),
        onChangeCallback: (value, component) => {
            const parentsSetToDarkMode = _checkParentsForDarkMode(component);

            const classListAction = (value === true || parentsSetToDarkMode === true) ? 'add' : 'remove';
            const darkModeElements = component.dom.root.querySelectorAll('[darkmode]');
    
            component.dom.root.classList[classListAction](`${component.styleSelector}--darkmode`);
            Array.prototype.forEach.call(darkModeElements, (darkModeElement) => {
                darkModeElement.darkmode = value;
            });
            
        }
    });

    const _checkParentsForDarkMode = (component) => {
        let element = component;

        while(element.parentNode) {
            element = element.parentNode;

            if (element.darkmode === true) {
                return true;
            }
        }

        return false;
    };

    const Direction = (options) => {
        const validOptions = [ 'column', 'row'];

        return new wealthify.Prop('direction', {
            ...options,
            nullable: true,
            type: wealthify.propTypes.ArrayItem(validOptions),
            onChangeCallback: (value, component) => {
                const rootElement = component.dom.childRoot ? component.dom.childRoot : component.dom.root;

                validOptions.forEach((option) => {
                    component.classList.remove(`u-flex__direction--${option}`);
                    rootElement.classList.remove(`u-flex__direction--${option}`);
                });

                if (!value) {
                    return;
                }

                component.classList.add(`u-flex__direction--${value}`);
                rootElement.classList.add(`u-flex__direction--${value}`);
            }
        });
    };

    const Disabled = (options) => new wealthify.Prop(options?.name || 'disabledprop', {
        ...options,
        default: false,
        type: wealthify.propTypes.Boolean(),
        onChangeCallback: (value, component) => {
            component.dom.root.disabled = value;

            if (wealthify.type.object.containsKeys(component.dom, 'input')) {
                const disabledAttribute = component.dom.input.tagName.toLowerCase() === 'input' ? 'disabled' : 'disabledprop';
                
                component.dom.input[disabledAttribute] = value;
            }
        }
    });

    const HeightProp = (options) => new wealthify.Prop('heightprop', {
        ...options,
        onChangeCallback: (value, component) => {
            component.style.height = value;
        }
    });

    const Hide = (options) => {
        const validNames = [
            'hide',
            'hidemobile',
            'hidetablet',
            'hidedesktop',
        ];
        const nameValid =  options.name && wealthify.type.array.includes(options.name, validNames);

        if (!nameValid) {
            return wealthify.error.throwError('Hide prop', `Name passed to Hide prop is invalid. Must be one of the following - ${validNames.join(', ')}`);
        }

        return new wealthify.Prop(options.name, {
            default: false,
            type: wealthify.propTypes.Boolean(),
            onChangeCallback: (value, component) => {
                const classListAction = value ? 'add' : 'remove';
                const breakpointName = options.name.split('hide')[1];
                const className = 'u-display__none-via-prop' + (breakpointName ? `--${breakpointName}` : '');

                component.classList[classListAction](className);
            }
        });
    };

    const Icon = (options) => new wealthify.Prop(options.name || 'icon', {
        ...options,
        onChangeCallback: (value, component) => {
            const name = options.name || 'icon';
            const elements = component.dom[name];

            if (!elements) {
                return wealthify.error.throwError('Icon prop', `DOM cache does not contain an element that matches [data-${name}].`);
            }

            const isMultiple = elements.length !== undefined;
            const areRelevantTags = isMultiple ? elements.every((element) => element.tagName.toLowerCase() === 'w-icon') : elements.tagName.toLowerCase() === 'w-icon';

            if (!areRelevantTags) {
                return wealthify.error.throwError('Icon prop', `Element [data-${name}] must be an instance of w-icon.`);
            }

            Array.prototype.forEach.call(isMultiple ? elements : [elements], (element) => {
                element.type = value;
            });
        }
    });

    const MinWidth = (options) => new wealthify.Prop('minwidth', {
        ...options,
        onChangeCallback: (value, component) => {
            component.style.minWidth = value;
        }
    });

    const MaxWidth = (options) => new wealthify.Prop('maxwidth', {
        ...options,
        onChangeCallback: (value, component) => {
            component.style.maxWidth = value;
        }
    });

    const MinHeight = (options) => new wealthify.Prop('minheight', {
        ...options,
        onChangeCallback: (value, component) => {
            const heightToAllowChildExpansion = '1px';

            component.style.minHeight = value;
            component.style.height = heightToAllowChildExpansion;
        }
    });

    const Order = (options) => {
        const validNames = [
            'orderdesktop',
            'ordermobile',
            'ordertablet',
            'ordertabletwide',
            'orderwide'
        ];
        const nameValid =  options.name && wealthify.type.array.includes(options.name, validNames);

        if (!nameValid) {
            return wealthify.error.throwError('Order prop', `Name passed to Order prop is invalid. Must be one of the following - ${validNames.join(', ')}`);
        }

        return new wealthify.Prop(options.name, {
            default: null,
            type: wealthify.propTypes.Number(),
            nullable: true,
            onChangeCallback: (value, component) => {
                if (value === null) {
                    return;
                }

                const breakpointName = options.name.split('order')[1];
                const relevantQuery = wealthify.breakpoints[breakpointName];

                const _updateOrderStyle = ((component, value, event) => {
                    const order = event.matches ? value : 0;

                    component.style.order = order;
                }).bind(null, component, value);
        
                relevantQuery.addEventListener('change', _updateOrderStyle);

                if (relevantQuery.matches) {
                    _updateOrderStyle(relevantQuery);
                }
            }
        });
    };

    const Sticky = (options) => {
        const validOptions = [ 'bottom', 'top'];

        return new wealthify.Prop('sticky', {
            ...options,
            nullable: true,
            type: wealthify.propTypes.ArrayItem(validOptions),
            onChangeCallback: (value, component) => {
                validOptions.forEach((option) => {
                    component.classList.remove(`u-align__sticky--${option}`);
                    component.dom.root.classList.remove(`u-align__sticky--${option}`);
                });

                if (!value) {
                    return;
                }

                component.classList.add(`u-align__sticky--${value}`);
                component.dom.root.classList.add(`u-align__sticky--${value}`);
            }
        });
    };

    return {
        AlignFlex,
        AlignText,
        AriaHidden,
        AriaDisabled,
        DarkMode,
        Direction,
        Disabled,
        HeightProp,
        Hide,
        Icon,
        MinWidth,
        MaxWidth,
        Order,
        MinHeight,
        Sticky
    };

})();